var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
// How many voters must connect Messenger again if the account's Page changes:
// those whose messenger-page is the current Page, in the events using it.
export var MESSAGING_ACCOUNT_CHANGE_IMPACT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query MessagingAccountChangeImpact($accountId: uuid!) {\n        messaging_account_change_impact(account_id: $accountId) {\n            affected_voters\n            events\n        }\n    }\n"], ["\n    query MessagingAccountChangeImpact($accountId: uuid!) {\n        messaging_account_change_impact(account_id: $accountId) {\n            affected_voters\n            events\n        }\n    }\n"])));
var templateObject_1;
